const componentBase = {
  borderRadius: '5px',
  borderWidth: '1px',
};

export const formikFiltersSectionTheme = {
  multiselectInputs: {
    error: {
      border: {
        ...componentBase,
        borderColor: 'palette.error.60',
      },
      label: {
        text: 'palette.error.60',
      },
    },
    inactive: {
      border: {
        ...componentBase,
        borderColor: 'palette.tertiary.20',
      },
      label: {
        text: 'palette.tertiary.60',
      },
    },
  },
};
